import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Dialog, Divider, Box, TextField } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { renameUserSession } from "../../redux/slice/rename-user-session";
import { useDispatch, useSelector } from "react-redux";
import { getUserSessions } from "../../redux/slice/get-user-sessions";
import { useLocation } from "react-router-dom";
import "./RenameDialog.scss";
import { initializeNoOfDays } from "../../redux/slice/snackbar";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function RenameDialog(props) {
  const { open, handleClose, name, userSessionId, handleRenamVal } = props;
  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const authUser = useSelector((state) => state.auth.user);
  const userEmail = authUser?.email || "";
  const token = "__cookie__";
  const { minRows, maxRows } = useSelector((state) => state.snackbar);
  // const client = queryParams.get('client');
  const client = "UT";
  const dispatchRenameProcess = () => {
    let nameone = {
      session_name: name,
    };
    const payload = {
      sessionId: userSessionId,
      data: nameone,
    };
    dispatch(renameUserSession(payload))
      .unwrap()
      .then(() => {
        const userSessionPayload = {
          userEmail: userEmail,
          token: token,
          client,
          minRows: 0,
          maxRows,
        };
        // Use ID from API 1 response to fetch data from API 2
        // dispatch(initializeNoOfDays())
        return dispatch(getUserSessions(userSessionPayload));
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    handleClose();
    // toggleDrawerClose()
  };

  return (
    <BootstrapDialog
      className="rename-dialog-parent"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="sm"
      fullWidth="true"
    >
      <DialogTitle
        sx={{ m: 0, p: 2, fontWeight: "bold" }}
        id="customized-dialog-title"
      >
        Rename Session
      </DialogTitle>
      <Typography
        sx={{ pl: 2, fontSize: "12px" }}
        className="rename-dialog-sub-title"
      >
        Give me much detail as you can, but do not include any private or
        sensitive information.
      </Typography>

      <TextField
        sx={{ padding: "10px" }}
        id="outlined-basic"
        value={name}
        onChange={(e) => handleRenamVal(e.target.value)}
        variant="outlined"
        style={{ marginTop: "20px", marginBottom: "30px" }}
      />
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className="rename-dialog-content">
        <Divider />
        <Box className="rename-dialog-buttons-holder">
          <Button
            variant="outlined"
            size="large"
            className="rename-dialog-cancel-button"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="large"
            className="rename-dialog-submit-button"
            onClick={dispatchRenameProcess}
          >
            Save
          </Button>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
}
